import React from 'react';
import {Task, getTaskStatusLabel} from 'entities/task';
import styles from './OrdersTable.module.css';

interface OrderStatusCellProps {
	task: Task;
}

const ERROR_STATUSES: Array<Task['status']> = ['error', 'canceled'];

export function OrderStatusCell({task}: OrderStatusCellProps): React.ReactElement {
	const isErrorStatus = task.status ? ERROR_STATUSES.includes(task.status) : false;

	return <span className={isErrorStatus ? styles.statusError : undefined}>{getTaskStatusLabel(task.status)}</span>;
}
